// extracted by mini-css-extract-plugin
export default {"content":"content_content__qMLRE","loading":"content_loading__4RACl"};